import React from 'react'
import BN_IS_X9 from '../../assets/media/products/BN_IS_X9_thumbnail.webp'
import BN_MCBS_X9 from '../../assets/media/products/BN_MCBS_X9_thumbnail.webp'
import BN_MPB_X9 from '../../assets/media/products/BN_MPB_X9_thumbnail.webp'
import BN_WMS_X9 from '../../assets/media/products/BN_WMS_X9_thumbnail.webp'
import CB_X9 from '../../assets/media/products/CB_X9_thumbnail.webp'
import NB_X9 from '../../assets/media/products/NB_X9_thumbnail.webp'
import VB_X9 from '../../assets/media/products/VB_X9_thumbnail.webp'
import WM_X9 from '../../assets/media/products/WM_X9_thumbnail.webp'
import WM2019_X9 from '../../assets/media/products/WM2019_X9_thumbnail.webp'
import vpnImg from '../../assets/media/products/thumbnail.png'
import IAV_thumbnailImg from '../../assets/media/products/IAV_thumbnail.webp'
import defaultProduct from '../../assets/media/products/no-product.png'
const Icon = ({ icon, fill = 'currentColor', size = '1x', product = false }) => {
  if (fill === 'danger') fill = '#FC1502'
  if (fill === 'success') fill = '#0076FF'
  if (fill === 'secondary') fill = '#adb5bd'
  if (product) {
    switch (icon) {
      case 'BN_IS_X9_thumbnail':
        return BN_IS_X9_img(fill)
      case 'BN_MCBS_X9_thumbnail':
        return BN_MCBS_X9_img(fill)
      case 'BN_MPB_X9_thumbnail':
        return BN_MPB_X9_img(fill)
      case 'BN_WMS_X9_thumbnail':
        return BN_WMS_X9_img(fill)
      case 'CB_X9_thumbnail':
        return CB_X9_img(fill)
      case 'NB_X9_thumbnail':
        return NB_X9_img(fill)
      case 'VB_X9_thumbnail':
        return VB_X9_img(fill)
      case 'WM_X9_thumbnail':
        return WM_X9_img(fill)
      case 'WM2019_X9_thumbnail':
        return WM2019_X9_img(fill)
      case 'IAV_thumbnail':
        return IAV_thumbnail(fill)
      case '_thumbnail':
        return vpn(fill)
      default:
        return defaultProduct_img(fill)
    }
  } else {
    switch (icon) {
      case 'account':
        return accountIcon(fill)
      case 'support':
        return supportIcon(fill)
      case 'devices':
        return devicesIcon(fill)
      case 'invoices':
        return invoicesIcon(fill)
      case 'knowledge':
        return knowledgeIcon(fill)
      case 'intego-one':
        return IntegoOneIcon(fill)
      case 'success':
        return successIcon(fill)
      case 'info':
        return infoIcon(fill)
      case 'breadcrumbs':
        return breadCrumbsIcon(fill)
      case 'downloadInvoice':
        return downloadInvoice(fill)
      case 'noInvoice':
        return noInvoice(fill)
      case 'trash':
        return trash(fill)
      case 'arrow':
        return arrow(fill)
      case 'eye':
        return eye(fill)
      case 'hidePassword':
        return hidePassword(fill)
      case 'passGreenCheck':
        return passGreenCheck(fill)
      case 'x':
        return x(fill)
      case 'greenCheck':
        return greenCheck(fill)
      case 'copyIcon':
        return copyIcon(fill)
	  case 'exportDevices':
	  	 return exportDevices(fill)
      default:
        return <>'no-icon'</>
    }
  }
}

const accountIcon = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49">
      <g transform="translate(-.315 -.297)">
        <g fill="#fff" stroke="#030133" strokeWidth="1" transform="translate(.315 .297)">
          <circle cx="24.5" cy="24.5" r="24.5" stroke="none" />
          <circle cx="24.5" cy="24.5" r="24" fill="none" />
        </g>
        <g fill="none" stroke="#0055FF" strokeMiterlimit="10" strokeWidth="1.5" transform="translate(15.465 12.404)">
          <path
            d="M9.749 9.748h0a3.9 3.9 0 01-3.9-3.9V3.9a3.9 3.9 0 013.9-3.9h0a3.9 3.9 0 013.9 3.9v1.95a3.9 3.9 0 01-3.9 3.898z"
            data-name="Path 152"
          />
          <path
            d="M6.007 12.672a.7.7 0 01.567.311 3.893 3.893 0 006.348 0 .7.7 0 01.567-.311h0a6 6 0 016 6v2.739a1 1 0 01-1 1H1a1 1 0 01-1-1v-2.739a6 6 0 016-6z"
            data-name="Path 153"
          />
        </g>
      </g>
    </svg>
  )
}

const devicesIcon = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49">
      <g transform="translate(.12 -.297)">
        <g fill="#fff" stroke="#030133" strokeWidth="1" transform="translate(-.12 .297)">
          <circle cx="24.5" cy="24.5" r="24.5" stroke="none" />
          <circle cx="24.5" cy="24.5" r="24" fill="none" />
        </g>
        <g
          fill="none"
          stroke="#0055FF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          data-name="Group 5707"
          transform="translate(14.481 15.446)"
        >
          <rect width="19" height="16" data-name="Rectangle 54" rx="1" transform="translate(.399 -.15)" />
          <path d="M0 0L19 0" data-name="Line 32" transform="translate(.399 12.85)" />
          <path d="M0 0H3V3H0z" data-name="Rectangle 55" transform="translate(8.399 15.85)" />
          <path d="M9 0L0 0" data-name="Line 33" transform="translate(5.399 18.85)" />
        </g>
      </g>
    </svg>
  )
}

const invoicesIcon = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49">
      <g transform="translate(-.272 -.297)">
        <g fill="#fff" stroke="#030133" strokeWidth="1" transform="translate(.272 .297)">
          <circle cx="24.5" cy="24.5" r="24.5" stroke="none" />
          <circle cx="24.5" cy="24.5" r="24" fill="none" />
        </g>
        <g fill="none" stroke="#0055FF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" transform="translate(14.967 11.727)">
          <path d="M16.442 23.636H1.028A1.028 1.028 0 010 22.608V5.138L5.138 0h11.3a1.028 1.028 0 011.028 1.028v21.58a1.028 1.028 0 01-1.024 1.028z" />
          <path d="M5.138 0v4.111A1.028 1.028 0 014.11 5.139H0z" />
          <path d="M0 0L9 0" transform="translate(4.306 12.569)" />
          <path d="M0 0L9 0" transform="translate(4.306 18.569)" />
        </g>
      </g>
    </svg>
  )
}

const knowledgeIcon = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="51" viewBox="0 0 49 51">
      <g transform="translate(.258 .399)">
        <g fill="#fff" stroke="#030133" strokeWidth="1" transform="translate(-.258 -.399)">
          <ellipse cx="24.5" cy="25.5" stroke="none" rx="24.5" ry="25.5" />
          <ellipse cx="24.5" cy="25.5" fill="none" rx="24" ry="25" />
        </g>
        <g fill="none" stroke="#005EFD" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" transform="translate(14.633 10.912)">
          <path d="M0 24.728V2.355A2.354 2.354 0 012.355 0h15.308a2.354 2.354 0 012.355 2.355v20.018H2.355" />
          <path d="M2.355 22.373h17.663c-2.355 1.178-2.355 3.533 0 4.71H2.355A2.354 2.354 0 010 24.728h0a2.354 2.354 0 012.355-2.355z" />
          <path d="M16.485 12.953L12.952 9.42 9.42 12.953V0h7.065z" />
        </g>
      </g>
    </svg>
  )
}

const IntegoOneIcon = (fill) => {
  return (
   <svg width="24" height="26" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.2656 0.0753381C11.7495 -0.0251164 12.2505 -0.025109 12.7344 0.0753381C13.2811 0.188938 13.7958 0.478795 14.8242 1.05874L21.1758 5.16323C21.4333 5.30842 21.6585 5.43568 21.8574 5.55092C22.4534 5.89613 22.8132 6.13532 23.0938 6.4396C23.4246 6.7985 23.6743 7.22155 23.8271 7.68081C23.8703 7.81065 23.9034 7.94442 23.9277 8.08999C23.9764 8.38126 23.9917 8.72031 23.9971 9.17202C23.9998 9.3975 24 9.65181 24 9.94155V16.4689C23.9998 16.5404 23.9975 16.6093 23.9971 16.6759C23.9966 16.749 23.9961 16.8192 23.9951 16.8869C23.9931 17.0249 23.9883 17.1521 23.9834 17.2707C23.98 17.3531 23.9771 17.4313 23.9717 17.506C23.9682 17.5543 23.9644 17.6011 23.96 17.6466C23.9583 17.6634 23.9578 17.68 23.9561 17.6964C23.9307 17.9295 23.8906 18.1286 23.8271 18.3195L23.7979 18.4054C23.7922 18.4209 23.7851 18.4359 23.7793 18.4513C23.7704 18.4748 23.7614 18.4983 23.752 18.5216C23.7402 18.5506 23.7273 18.579 23.7148 18.6076C23.7034 18.6337 23.6918 18.6598 23.6797 18.6857C23.6659 18.7152 23.6514 18.7444 23.6367 18.7736C23.6259 18.795 23.6158 18.8168 23.6045 18.838C23.4664 19.0986 23.2958 19.3425 23.0938 19.5617L23.0215 19.6359C23.0045 19.6529 22.9854 19.668 22.9678 19.6847C22.952 19.6997 22.9363 19.7149 22.9199 19.7296C22.8862 19.7601 22.8509 19.7896 22.8145 19.8195C22.7934 19.8368 22.772 19.854 22.75 19.8712C22.7128 19.9003 22.6741 19.929 22.6338 19.9582C22.6119 19.974 22.5903 19.991 22.5674 20.007C22.5217 20.0389 22.4739 20.0709 22.4238 20.1037C22.4046 20.1162 22.3851 20.129 22.3652 20.1417C22.246 20.2181 22.1137 20.2968 21.9668 20.383C21.923 20.4087 21.8786 20.4361 21.832 20.463C21.6393 20.5744 21.4226 20.6979 21.1758 20.8371L14.8242 24.9415L14.4619 25.1457C14.1141 25.3406 13.8298 25.4919 13.582 25.6124C13.5516 25.6273 13.5226 25.6435 13.4932 25.6574C13.4592 25.6733 13.4254 25.6877 13.3926 25.7023C13.289 25.7485 13.1914 25.7896 13.0957 25.8234C13.0858 25.8269 13.0753 25.8288 13.0654 25.8322C12.9533 25.8705 12.8447 25.902 12.7344 25.9249L12.6436 25.9425C12.6356 25.944 12.6271 25.9441 12.6191 25.9455C12.5277 25.9614 12.4359 25.9738 12.3438 25.9826C12.3255 25.9843 12.3073 25.986 12.2891 25.9874C12.096 26.0029 11.9021 26.003 11.709 25.9874C11.6917 25.9861 11.6745 25.9852 11.6572 25.9835C11.5633 25.9746 11.47 25.9608 11.377 25.9445C11.3705 25.9434 11.3638 25.9437 11.3574 25.9425L11.2812 25.9279C11.2761 25.9268 11.2708 25.926 11.2656 25.9249C11.155 25.902 11.0461 25.8706 10.9336 25.8322C10.9247 25.8291 10.9152 25.8275 10.9062 25.8244L10.8945 25.8205C10.7909 25.7835 10.6847 25.7382 10.5713 25.6867C10.5527 25.6782 10.5336 25.6701 10.5146 25.6613C10.4609 25.6361 10.4068 25.6068 10.3496 25.5783C10.1186 25.4631 9.85493 25.3227 9.53906 25.1457L9.17578 24.9415L2.82422 20.8371C2.57708 20.6977 2.35995 20.5745 2.16699 20.463C2.12043 20.4361 2.07601 20.4086 2.03223 20.383C1.88654 20.2975 1.75512 20.2195 1.63672 20.1437C1.60099 20.1208 1.56677 20.0977 1.5332 20.0753C1.50693 20.0578 1.48108 20.0408 1.45605 20.0236C1.41311 19.994 1.37256 19.9639 1.33301 19.9347C1.30883 19.9169 1.28473 19.8998 1.26172 19.882C1.22901 19.8567 1.19756 19.8313 1.16699 19.8058C1.14111 19.7842 1.1163 19.7622 1.0918 19.7404C1.0664 19.7178 1.04164 19.6951 1.01758 19.672C1.00482 19.6598 0.990931 19.6483 0.978516 19.6359L0.907227 19.5617C0.788853 19.4333 0.680921 19.296 0.583984 19.1525C0.565431 19.125 0.547031 19.0975 0.529297 19.0695C0.514341 19.0459 0.499719 19.0221 0.485352 18.9982C0.45015 18.9395 0.416367 18.8801 0.384766 18.8195L0.333984 18.7179C0.328878 18.7073 0.324332 18.6964 0.319336 18.6857C0.307247 18.6598 0.295618 18.6337 0.28418 18.6076C0.271733 18.5791 0.259713 18.5504 0.248047 18.5216C0.235482 18.4906 0.223565 18.4593 0.211914 18.4279C0.209119 18.4203 0.205867 18.413 0.203125 18.4054L0.172852 18.3195C0.149964 18.2507 0.130509 18.1807 0.113281 18.1085C0.110977 18.0989 0.109633 18.089 0.107422 18.0792C0.0966577 18.0319 0.0868157 17.9835 0.078125 17.9337C0.0728239 17.9033 0.0680724 17.8724 0.0634766 17.841C0.0581682 17.8046 0.0522915 17.7677 0.0478516 17.7296C0.0428991 17.6872 0.0391302 17.6436 0.0351562 17.5988C0.0332472 17.5773 0.0309984 17.5555 0.0292969 17.5333C0.022661 17.447 0.0195505 17.3558 0.015625 17.2589C0.0111184 17.1477 0.0068159 17.0288 0.00488281 16.9005C0.00330454 16.796 0.00149135 16.6853 0.000976562 16.5675C0.000835907 16.5352 0.00106492 16.5023 0.000976562 16.4689L0 9.94057C1.36544e-09 9.81665 0.000764095 9.69935 0.000976562 9.58803C0.00126536 9.43426 0.00226041 9.29192 0.00390625 9.15932C0.00407403 9.14588 0.0037182 9.13253 0.00390625 9.11928C0.0066489 8.92514 0.0114675 8.75216 0.0205078 8.59487C0.0239708 8.53472 0.028451 8.47691 0.0332031 8.42104C0.0345154 8.4056 0.0356885 8.39029 0.0371094 8.37514C0.0417083 8.32616 0.0469063 8.27872 0.0527344 8.23256C0.0571883 8.19727 0.0631109 8.16292 0.0683594 8.12905C0.0732395 8.09757 0.0783642 8.06669 0.0839844 8.03628C0.0914016 7.99613 0.0986082 7.95671 0.107422 7.91811C0.113678 7.89071 0.120918 7.86383 0.12793 7.83706C0.13297 7.81781 0.137128 7.79842 0.142578 7.77944L0.172852 7.68081C0.190686 7.62721 0.21002 7.57418 0.230469 7.52163V7.52065C0.242384 7.49005 0.255766 7.46006 0.268555 7.42983C0.302285 7.35011 0.338253 7.27137 0.37793 7.19448C0.398501 7.15461 0.420251 7.11536 0.442383 7.07631C0.448195 7.06606 0.453065 7.05526 0.458984 7.04506C0.471817 7.02296 0.485693 7.00146 0.499023 6.97963C0.519071 6.94682 0.539388 6.91413 0.560547 6.88198C0.576474 6.85777 0.593802 6.83451 0.610352 6.81069C0.626367 6.78764 0.641611 6.76403 0.658203 6.74135C0.670808 6.72413 0.684331 6.70758 0.697266 6.69057C0.718612 6.66251 0.739485 6.63403 0.761719 6.60659C0.782061 6.58148 0.803144 6.55694 0.824219 6.53237C0.831274 6.52414 0.838567 6.51612 0.845703 6.50796L0.875 6.47475C0.885428 6.46312 0.895655 6.45109 0.90625 6.4396C0.97444 6.36564 1.04812 6.29643 1.12793 6.22768C1.14764 6.21069 1.16691 6.19278 1.1875 6.17592C1.21693 6.15184 1.2479 6.12863 1.2793 6.10463C1.3118 6.07978 1.34505 6.05444 1.37988 6.02944C1.40141 6.014 1.42381 5.99911 1.44629 5.98354C1.48029 5.95998 1.51542 5.93627 1.55176 5.91225C1.61035 5.87355 1.673 5.83562 1.73828 5.79506C1.84894 5.72629 1.96873 5.65263 2.10156 5.57534C2.16276 5.53973 2.2265 5.50302 2.29297 5.46499C2.34748 5.4338 2.40363 5.40137 2.46191 5.36831L2.82422 5.16323L9.17578 1.05874C9.30365 0.986634 9.42408 0.91994 9.53711 0.856588C9.64671 0.795149 9.74909 0.736381 9.84668 0.68276C9.87511 0.667144 9.90413 0.653789 9.93164 0.638815C10.0966 0.54904 10.2448 0.469468 10.3828 0.40151C10.4138 0.38628 10.4447 0.37274 10.4746 0.358541C10.5136 0.340018 10.5514 0.321646 10.5889 0.30483C10.6347 0.284252 10.6797 0.265321 10.7236 0.247213C10.7497 0.236484 10.7753 0.225853 10.8008 0.215963C10.8377 0.201669 10.8741 0.188515 10.9102 0.175924C10.9493 0.162249 10.9879 0.14958 11.0264 0.137838C11.0505 0.130474 11.0746 0.123959 11.0986 0.11733C11.1205 0.111281 11.1422 0.104228 11.1641 0.0987756L11.2559 0.0772912C11.2591 0.0766051 11.2624 0.0760117 11.2656 0.0753381ZM10.1787 23.3214C11.2761 23.9395 11.4835 24.0324 11.6621 24.0695L11.7461 24.0841C11.9426 24.1145 12.1438 24.11 12.3389 24.0695L12.373 24.0617C12.547 24.0187 12.7943 23.9004 13.8223 23.3214L17.3848 21.0197H6.61523L10.1787 23.3214ZM6.47461 19.7345H17.5127C17.4988 18.3079 17.482 16.9081 17.4639 15.6496H6.52148C6.50477 16.9067 6.48714 18.3079 6.47461 19.7345ZM11.9961 3.72768C11.3359 3.72768 10.6987 3.74236 10.0664 3.76772V8.12905H7.68262V5.66225C6.75071 5.75035 5.86451 5.86158 5.03809 5.99917L4.7627 6.1769C4.75811 7.48967 4.89785 8.79942 5.18066 10.0841L6.60742 11.5529C6.60694 11.5791 6.58589 12.6925 6.5625 14.3644H17.4424C17.4162 12.6926 17.395 11.5793 17.3945 11.5529L18.8193 10.0841C19.1015 8.7993 19.2403 7.48966 19.2363 6.1769L18.9609 5.99917C18.1362 5.86182 17.2498 5.75024 16.3203 5.66225L16.3105 8.12905H13.9297V3.76772C13.2974 3.74237 12.6562 3.72768 11.9961 3.72768Z" fill="#005EFD"/>
</svg>



  )
}

const supportIcon = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="51" viewBox="0 0 49 51">
  <g transform="translate(-.315 .399)">
  <g fill="none" stroke="#005EFD" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" transform="translate(12.955 13.62)">
          <path d="M18.198 14.243l5.217 5.217a2.238 2.238 0 010 3.162l-.793.793a2.238 2.238 0 01-3.161 0l-5.217-5.217" />
          <path d="M5.888 9.843L.671 4.626a2.239 2.239 0 010-3.162l.793-.793a2.239 2.239 0 013.162 0l5.217 5.217" />
          <path d="M14.243 5.888L19.46.671a2.238 2.238 0 013.161 0l.793.793a2.238 2.238 0 010 3.162l-5.217 5.217" />
          <path d="M5.888 14.243L.671 19.46a2.239 2.239 0 000 3.162l.793.793a2.239 2.239 0 003.162 0l5.217-5.217" />
          <path d="M5.966 2.011a10.187 10.187 0 0112.153 0" />
          <path d="M5.966 22.074a10.187 10.187 0 0012.153 0" />
          <path d="M2.011 18.119a10.186 10.186 0 010-12.153" />
          <path d="M22.074 5.966a10.188 10.188 0 010 12.153" />
          <circle cx="6" cy="6" r="6" transform="translate(6.36 5.981)" />
        </g>
      </g>
    </svg>
  )
}

const successIcon = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.5" height="20.5" viewBox="0 0 20.5 20.5" className="checkmark">
      <g fill="none" stroke="#005EFD" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" transform="translate(-959.75 -1127.75)">
        <circle cx="9.5" cy="9.5" r="9.5" transform="translate(960.5 1128.5)" className="checkmark__circle" />
        <path className="checkmark__check" d="M7 0L0 7" transform="translate(968.5 1134.5)" />
        <path className="checkmark__check" d="M0 0L4 3" transform="translate(964.5 1138.5)" />
      </g>
    </svg>
  )
}

const infoIcon = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="34" viewBox="0 0 26 34">
      <g fill="#ebebeb" stroke="#a7a7a7" transform="translate(-682 -435) translate(682 440)">
        <circle cx="13" cy="13" r="13" stroke="none" />
        <circle cx="13" cy="13" r="12.5" fill="none" />
      </g>
      <text
        fill="#a7a7a7"
        fontFamily="SourceSansPro-Bold, Source Sans Pro"
        fontSize="21"
        fontWeight="700"
        transform="translate(-682 -440) translate(692 444)"
        className="tspan_i"
      >
        <tspan x="0" y="22">
          i
        </tspan>
      </text>
    </svg>
  )
}

const breadCrumbsIcon = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="4.733" height="9.407" viewBox="0 0 4.733 9.407">
      <g transform="translate(-469 -104.999)">
        <path
          d="M14.169,16.862a.67.67,0,0,1-.516-1.1l3-3.594-2.9-3.6a.685.685,0,1,1,1.079-.845l3.238,4.023a.67.67,0,0,1,0,.851l-3.352,4.023A.67.67,0,0,1,14.169,16.862Z"
          transform="translate(455.502 97.543)"
          fill="#030133"
        />
      </g>
    </svg>
  )
}

const downloadInvoice = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.983" height="20.801" viewBox="0 0 19.983 20.801">
      <g id="Group_5813" data-name="Group 5813" transform="translate(-191.5 -287.5)">
        <g id="Group_5812" data-name="Group 5812" transform="translate(197.405 299.944)">
          <line
            id="Line_754"
            data-name="Line 754"
            x1="4"
            y2="5"
            transform="translate(4.095 -0.444)"
            fill="none"
            stroke="#0055FF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <line
            id="Line_755"
            data-name="Line 755"
            x2="4"
            y2="5"
            transform="translate(0.095 -0.444)"
            fill="none"
            stroke="#0055FF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
        <path
          id="Path_7826"
          data-name="Path 7826"
          d="M210.483,305.5v4.087a.824.824,0,0,1-.817.817H193.3a.809.809,0,0,1-.8-.817V305.5"
          transform="translate(0 -3.104)"
          fill="none"
          stroke="#0055FF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <line
          id="Line_756"
          data-name="Line 756"
          y2="16"
          transform="translate(201.5 288.5)"
          fill="none"
          stroke="#0055FF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  )
}

const exportDevices = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.983" height="20.801" viewBox="0 0 19.983 20.801">
      <g id="Group_5813" data-name="Group 5813" transform="translate(-191.5 -287.5)">
        <g id="Group_5812" data-name="Group 5812" transform="translate(197.405 299.944)">
          <line
            id="Line_754"
            data-name="Line 754"
            x1="4"
            y2="5"
            transform="translate(4.095 -0.444)"
            fill="none"
            stroke="#0055FF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <line
            id="Line_755"
            data-name="Line 755"
            x2="4"
            y2="5"
            transform="translate(0.095 -0.444)"
            fill="none"
            stroke="#0055FF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
        <path
          id="Path_7826"
          data-name="Path 7826"
          d="M210.483,305.5v4.087a.824.824,0,0,1-.817.817H193.3a.809.809,0,0,1-.8-.817V305.5"
          transform="translate(0 -3.104)"
          fill="none"
          stroke="#0055FF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <line
          id="Line_756"
          data-name="Line 756"
          y2="16"
          transform="translate(201.5 288.5)"
          fill="none"
          stroke="#0055FF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  )
}

const noInvoice = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19.983" height="20.801" viewBox="0 0 19.983 20.801">
      <g id="Group_5813" data-name="Group 5813" transform="translate(-191.5 -287.5)">
        <g id="Group_5812" data-name="Group 5812" transform="translate(197.405 299.944)">
          <line
            id="Line_754"
            data-name="Line 754"
            x1="4"
            y2="5"
            transform="translate(4.095 -0.444)"
            fill="none"
            stroke="#D8D8D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <line
            id="Line_755"
            data-name="Line 755"
            x2="4"
            y2="5"
            transform="translate(0.095 -0.444)"
            fill="none"
            stroke="#D8D8D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
        <path
          id="Path_7826"
          data-name="Path 7826"
          d="M210.483,305.5v4.087a.824.824,0,0,1-.817.817H193.3a.809.809,0,0,1-.8-.817V305.5"
          transform="translate(0 -3.104)"
          fill="none"
          stroke="#D8D8D8"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <line
          id="Line_756"
          data-name="Line 756"
          y2="16"
          transform="translate(201.5 288.5)"
          fill="none"
          stroke="#D8D8D8"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  )
}
const trash = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="28" viewBox="0 0 20 28">
      <g transform="translate(0.5 1)">
        <path
          d="M0,0H15a0,0,0,0,1,0,0V17a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V0A0,0,0,0,1,0,0Z"
          transform="translate(1.5 7)"
          fill="none"
          stroke="#cc0d18"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M1,0H17a1,1,0,0,1,1,1V4a0,0,0,0,1,0,0H0A0,0,0,0,1,0,4V1A1,1,0,0,1,1,0Z"
          transform="translate(0.5 3)"
          fill="none"
          stroke="#cc0d18"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M1,0H8A1,1,0,0,1,9,1V3A0,0,0,0,1,9,3H0A0,0,0,0,1,0,3V1A1,1,0,0,1,1,0Z"
          transform="translate(4.5)"
          fill="none"
          stroke="#cc0d18"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <line y2="11" transform="translate(5.5 10)" fill="none" stroke="#cc0d18" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        <line y2="11" transform="translate(9.5 10)" fill="none" stroke="#cc0d18" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        <line y2="11" transform="translate(12.5 10)" fill="none" stroke="#cc0d18" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
      </g>
    </svg>
  )
}
const x = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.707" height="14.707" viewBox="0 0 14.707 14.707">
      <g transform="translate(-903.146 -279.146)">
        <line x1="14" y2="14" transform="translate(903.5 279.5)" fill="none" stroke="#fff" strokeWidth="1" />
        <line x2="14" y2="14" transform="translate(903.5 279.5)" fill="none" stroke="#fff" strokeWidth="1" />
      </g>
    </svg>
  )
}
const arrow = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="27.235" height="15.845" viewBox="0 0 27.235 15.845">
      <g transform="translate(1.413 1.413)">
        <line x1="12.204" y2="13.018" transform="translate(12.204)" fill="none" stroke="#030133" strokeLinecap="round" strokeWidth="2" />
        <line x2="12.204" y2="13.018" fill="none" stroke="#030133" strokeLinecap="round" strokeWidth="2" />
      </g>
    </svg>
  )
}
const eye = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
      <g transform="translate(-1488 -340)">
        <path
          d="M1511.5,348s-4,7.5-11.5,7.5-11.5-7.5-11.5-7.5,4-7.5,11.5-7.5S1511.5,348,1511.5,348Z"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <circle
          cx="4.5"
          cy="4.5"
          r="4.5"
          transform="translate(1495.5 343.5)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </svg>
  )
}
const hidePassword = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20.412" viewBox="0 0 24 20.412">
      <g transform="translate(-1488 -241.794)">
        <path
          d="M1511.5,252s-4,7.5-11.5,7.5-11.5-7.5-11.5-7.5,4-7.5,11.5-7.5S1511.5,252,1511.5,252Z"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <circle
          cx="4.5"
          cy="4.5"
          r="4.5"
          transform="translate(1495.5 247.5)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <line x1="17" y2="19" transform="translate(1491.5 242.5)" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" />
      </g>
    </svg>
  )
}
const passGreenCheck = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.5" height="20.5" viewBox="0 0 20.5 20.5">
      <g transform="translate(-959.75 -1127.75)">
        <circle
          cx="9.5"
          cy="9.5"
          r="9.5"
          transform="translate(960.5 1128.5)"
          fill="none"
          stroke="#005EFD"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="7"
          y2="7"
          transform="translate(968.5 1134.5)"
          fill="none"
          stroke="#005EFD"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x2="4"
          y2="3"
          transform="translate(964.5 1138.5)"
          fill="none"
          stroke="#005EFD"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  )
}
const BN_IS_X9_img = (fill) => {
  return <img src={BN_IS_X9} alt="product" />
}
const BN_MCBS_X9_img = (fill) => {
  return <img src={BN_MCBS_X9} alt="product" />
}
const BN_MPB_X9_img = (fill) => {
  return <img src={BN_MPB_X9} alt="product" />
}
const BN_WMS_X9_img = (fill) => {
  return <img src={BN_WMS_X9} alt="product" />
}
const CB_X9_img = (fill) => {
  return <img src={CB_X9} alt="product" />
}
const NB_X9_img = (fill) => {
  return <img src={NB_X9} alt="product" />
}
const VB_X9_img = (fill) => {
  return <img src={VB_X9} alt="product" />
}
const WM_X9_img = (fill) => {
  return <img src={WM_X9} alt="product" />
}
const WM2019_X9_img = (fill) => {
  return <img src={WM2019_X9} alt="product" />
}
const IAV_thumbnail = (fill) => {
  return <img src={IAV_thumbnailImg} alt="product" />
}
const vpn = (fill) => {
  return <img src={vpnImg} alt="product" />
}
const defaultProduct_img = (fill) => {
  return <img src={defaultProduct} alt="product" />
}
const greenCheck = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7156 0.750212C12.0837 1.09413 12.0961 1.66385 11.7434 2.02272L4.66645 9.22271C4.49471 9.39745 4.25802 9.49737 4.00982 9.49995C3.76161 9.50252 3.5228 9.40753 3.34729 9.2364L0.270363 6.2364C-0.090121 5.88492 -0.090121 5.31508 0.270363 4.9636C0.630847 4.61213 1.21531 4.61213 1.57579 4.9636L3.98596 7.31352L10.4105 0.777286C10.7632 0.418418 11.3475 0.406296 11.7156 0.750212Z"
        fill="#005EFD"
      />
    </svg>
  )
}
const copyIcon = (fill) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clip-path="url(#clip0_447_9658)">
        <path
          d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z"
          fill={fill}
        />
        <path
          d="M17.5 16V6.5C17.5 6.22386 17.2761 6 17 6H9.5C9.22386 6 9 6.22386 9 6.5V16C9 16.2761 9.22386 16.5 9.5 16.5H17C17.2761 16.5 17.5 16.2761 17.5 16Z"
          stroke="#9D9D9D"
        />
        <path d="M7 8V18C7 18.2761 7.22386 18.5 7.5 18.5H15" stroke="#9D9D9D" stroke-linecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_447_9658">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Icon
